import {
  SIZE_LARGE,
  SIZE_LARGE_LABEL,
  SIZE_MEDIUM,
  SIZE_MEDIUM_LABEL,
  SIZE_SMALL,
  SIZE_SMALL_LABEL
} from './size'

export const FONT_SIZE_SMALL_SIZE = '13px'
export const FONT_SIZE_MEDIUM_SIZE = '15px'
export const FONT_SIZE_LARGE_SIZE = '26px'
export const FONT_SIZE_EXTRA_LARGE_SIZE = '36px'

export const DEFAULT_FONT_FAMILY = 'National 2'
export const DEFAULT_FONT_FAMILY_STYLE = '"National 2", sans-serif'

export const DEFAULT_FONT_FAMILIES = [
  'Dancing Script',
  'Lato',
  'Lora',
  'Merriweather',
  'Open Sans',
  'Playfair Display',
  'PT Serif',
  'Roboto'
]

export const DEFAULT_PICKER_COLORS = [
  '#434A54', '#4D4D4D', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF',
  '#333333', '#666666', '#F6F7FB', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF',
  '#000000', '#656D78', '#808080', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'
]

export const DEFAULT_BUTTON_SIZE = SIZE_SMALL
export const DEFAULT_BUTTON_SHAPE = 'square'
export const DEFAULT_BUTTON_POSITION = 'left'
export const DEFAULT_BUTTON_COLOR = '#2685C6'
export const DEFAULT_BUTTON_FONT_COLOR = '#FFFFFF'
export const DEFAULT_FONT_COLOUR = '#434A54'
export const DEFAULT_LINE_COLOR = '#E6E9EE'
export const DEFAULT_FORM_BACKGROUND_COLOR = '#FFFFFF'
export const DEFAULT_WALLPAPER_COLOR = '#F6F7FB'
export const DEFAULT_OPACITY = 100

export const QUESTION_TITLE_FONT_SIZES = [{
  label: SIZE_SMALL_LABEL,
  size: FONT_SIZE_SMALL_SIZE,
  value: SIZE_SMALL
}, {
  label: SIZE_MEDIUM_LABEL,
  size: FONT_SIZE_MEDIUM_SIZE,
  value: SIZE_MEDIUM
}, {
  label: SIZE_LARGE_LABEL,
  size: FONT_SIZE_LARGE_SIZE,
  value: SIZE_LARGE
}]

export const SUBMIT_BUTTON_LEFT_POSITION = 'left'
export const SUBMIT_BUTTON_CENTER_POSITION = 'center'
export const SUBMIT_BUTTON_RIGHT_POSITION = 'right'
export const SUBMIT_BUTTON_SHAPE_SQUARE = 'square'
export const SUBMIT_BUTTON_SHAPE_SEMI_ROUND = 'semi_round'
export const SUBMIT_BUTTON_SHAPE_ROUND = 'round'

export const SUBMIT_BUTTON_SIZES = [ SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE ]
